import React from 'react';
import _ from 'lodash';

export const useUiSettingsAutosave = (
  domain: any,
  whitelist: any,
  blacklist: any = []
) => {
  const watchlist = _.omit(whitelist, [
    'page',
    'search',
    'searchAfter',
    'pageRequested',
    ...blacklist,
  ]);
  const store = JSON.parse(localStorage.getItem('cowbell')) || {};
  const { uiSettings = {} } = store;

  React.useEffect(
    () => {
      if (Object.prototype.hasOwnProperty.call(watchlist, 'columns')) {
        // @ts-expect-error: FIXME
        watchlist.columns = Object.values(watchlist.columns).reduce(
          (acc, col) => ({
            // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
            ...acc,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            [col.name]: { name: col.name, show: col.show },
          }),
          {}
        );
      }

      localStorage.setItem(
        'cowbell',
        JSON.stringify({
          ...store,
          uiSettings: { ...uiSettings, [domain]: watchlist },
        })
      );
    },
    // eslint-disable-next-line
    [watchlist]
  );
};
